import { useRef } from "react";
import TagInput from "@/components/ui/TagInput";

interface TypeTagInputProps {
  value: string[];
  onChange: (tags: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function TypeTagInput({ value, onChange, disabled, placeholder }: TypeTagInputProps) {
  const previousValue = useRef<string[]>(value);

  const handleChange = async (newValue: string[]) => {
    const previous = previousValue.current;
    previousValue.current = newValue;

    const added = newValue.filter((v) => !previous.includes(v));
    for (const tag of added) {
      try {
        await fetch("/api/company-classification/terms", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ field: "typeTags", label: tag, source: "user_created", confirmed: true }),
        });
      } catch (error) {
        console.error("[TypeTagInput] Failed to create:", error);
      }
    }

    onChange(newValue);
  };

  return (
    <TagInput
      value={value}
      onChange={handleChange}
      disabled={disabled}
      placeholder={placeholder}
      suggestionsEndpoint="/api/company-classification/terms?field=typeTags"
    />
  );
}
